// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"ExperienceDetails_detailsContainer__V40VL"};